import { fromZonedTime } from "date-fns-tz";
import { APP_CONFIG } from "../../constants/constants";
import { REPORT_FIELD_OUTPUT_TYPES } from "./constants";
import { REPORT_ENTITIES, TReportTypes } from "./type";
import { TReportField } from "../../api/types/Report";

// TODO: deprecated
export const getReportEntity = (reportType: TReportTypes) => {
  switch (reportType) {
    case "driver_details_report":
    case "driver_performance_report":
      return REPORT_ENTITIES.DRIVER;
    default:
      return REPORT_ENTITIES.VEHICLE;
  }
};

// navigateOnReportOptionsChange moved to pages/reports/hooks/reportUtils.ts

// getValuesWithCalcUnixTimestamps moved to pages/reports/hooks/reportUtils.ts

export const getFieldSpecificFilterOptions = (
  fieldOutputType: REPORT_FIELD_OUTPUT_TYPES
) => {
  let optionsDropdownValues: string[] = [];
  switch (fieldOutputType) {
    case REPORT_FIELD_OUTPUT_TYPES.NUMBER:
    case REPORT_FIELD_OUTPUT_TYPES.KPH_TO_SPEED_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.KM_TO_DISTANCE_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.M_TO_DISTANCE_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.L_TO_VOLUME_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.KPL_ECONOMY_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.KPA_TO_PRESSURE_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.C_TO_TEMPERATURE_UNITS:
    case REPORT_FIELD_OUTPUT_TYPES.SEC_TO_HOURS:
    case REPORT_FIELD_OUTPUT_TYPES.SEC_TO_HH_MM_SS:
    case REPORT_FIELD_OUTPUT_TYPES.DECI_SEC_TO_HH_MM_SS:
      optionsDropdownValues = [
        "GREATER_THAN",
        "GREATER_THAN_EQUAL",
        "LESS_THAN",
        "LESS_THAN_EQUAL",
        "BETWEEN",
      ];
      break;
    case REPORT_FIELD_OUTPUT_TYPES.DATE:
    case REPORT_FIELD_OUTPUT_TYPES.DATE_TIME:
    case REPORT_FIELD_OUTPUT_TYPES.TIME:
    case REPORT_FIELD_OUTPUT_TYPES.GREGORIAN_DATE:
      optionsDropdownValues = ["EQUAL", "BEFORE", "AFTER", "BETWEEN"];
      break;
    case REPORT_FIELD_OUTPUT_TYPES.ACTIVE_INACTIVE_DROPDOWN:
      optionsDropdownValues = ["EQUAL", "NOT_EQUAL"];
      break;
    case REPORT_FIELD_OUTPUT_TYPES.TEXT:
    default:
      optionsDropdownValues = ["LIKE", "NOT_LIKE", "EQUAL"];
  }
  return optionsDropdownValues;
};

export const convertToReportTableColumn = (field: TReportField) => {
  return {
    header: field.field.name,
    id: field.field.id.toString(),
    identifier: field.identifier,
    ordering: field.field.ordering,
    show_selectable_values: !!field.dropdown,
    aggregation_applied: !!field.aggregate_function,
    field_output_type: field.output_type,
    all_field_id: field.field.all_field_id,
    field_object: field,
  };
};
